import React, { useEffect, useRef, useState, useContext } from "react";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import { useNavigate } from "react-router-dom";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { ContextBoard } from "../../context/ContextBoard";
import Swal from "sweetalert2";
import config from "../../config";

function Addstudentregular12() {
  const [isLoading, setIsLoading] = useState(false);
  const [studentData, setStudentData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const {
    setCandidateid12,
    setMode12,
    setDivyangcode12,
    setCastecode12,
    setClass12regulardata,
  } = useContext(ContextBoard);

  const navigate = useNavigate();
  useEffect(() => {
    setCandidateid12("");
    setDivyangcode12("");
    setCastecode12("");
    setMode12("");
    const token = sessionStorage.getItem("tokenclassxii");
    const fetchStudents = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${config.API_BASE_URL}/FetchSourceDataBySchool_CL12`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            // body: JSON.stringify({
            //   schooL_CODE: schoolCode,
            // }),
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Validation failed");
        }

        const data = await response.json();
        // console.log("Total Registration Data:", data);
        setStudentData(data.data.studentsData || []);
        // console.log(data.data["student-data"] || []);
      } catch (error) {
        console.error("Error fetching students:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStudents();
  }, []);

  const filteredStudents = studentData.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.registratioN_ID_CL_11?.toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  const updatedLateralstatus = sessionStorage.getItem("Class12LateralStatus");
  const handleViewData = async (candidate) => {
    const token = sessionStorage.getItem("tokenclassxii");
    const candidateId = candidate;

    const apiUrl =
      updatedLateralstatus === "ON"
        ? `FetchSourceRegularDataByCandidateID_CL12Lateral`
        : `FetchSourceRegularDataByCandidateID_CL12`;
    try {
      const response = await fetch(`${config.API_BASE_URL}/${apiUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          candidatE_ID: candidateId,
        }),
      });

      const result = await response.json();

      if (!response.ok || result.status === 404) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.message || "Something went wrong",
        });
        return;
      }

      setClass12regulardata(true);
      navigate("/class-xii-regular-student-info", {
        state: { candidateData: result.data.studentSourceReg_data },
      });
    } catch (error) {
      console.error("Error fetching data:", error.message);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Failed to fetch data",
      });
    }
  };

  return (
    <>
      <div class="container-scroller">
        {isLoading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Navbar12 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar12 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Class XII Student Register</h4>
                    </div>
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center">
                          <label htmlFor="rowsPerPage" className="me-2 mb-0">
                            Rows:
                          </label>
                          <div style={{ width: "250px" }}>
                            <select
                              id="rowsPerPage"
                              className="form-select form-select-sm"
                              value={perPage}
                              onChange={handlePerPageChange}
                              style={{
                                width: "80px", // or adjust as needed (80–120px)
                                paddingRight: "2rem", // ensures space for the dropdown arrow
                              }}
                            >
                              {[10, 20, 50, 100, 500].map((num) => (
                                <option key={num} value={num}>
                                  {num}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {/* Search on the right */}
                        <div style={{ width: "200px" }}>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                        </div>
                      </div>

                      {isLoading ? (
                        <p>Loading...</p>
                      ) : (
                        <div className="table-responsive">
                          <table className="table table-striped table-condensed table-bordered">
                            <thead>
                              <tr className="table-info">
                                <th>Sl. No</th>
                                <th>Name of Candidate</th>
                                <th>Father's Name</th>
                                <th>Mother's Name</th>
                                <th>Registration No.</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentItems.length === 0 ? (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    No data found.
                                  </td>
                                </tr>
                              ) : (
                                currentItems.map((row, index) => (
                                  <tr key={index}>
                                    <td>
                                      {(currentPage - 1) * perPage + index + 1}
                                    </td>
                                    <td>{row.candidatE_NAME}</td>
                                    <td>{row.fatheR_NAME}</td>
                                    <td>{row.motheR_NAME}</td>
                                    <td>{row.registratioN_ID_CL_11}</td>
                                    <td>
                                      <button
                                        className="btn btn-sm btn-info"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleViewData(row.candidatE_ID);
                                        }}
                                      >
                                        View Data
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}

                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          Showing {(currentPage - 1) * perPage + 1} to{" "}
                          {Math.min(indexOfLastItem, filteredStudents.length)}{" "}
                          of {filteredStudents.length} entries
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <MdOutlineKeyboardDoubleArrowLeft
                            onClick={() => {
                              if (currentPage > 1) setCurrentPage(1);
                            }}
                            style={{
                              cursor:
                                currentPage > 1 ? "pointer" : "not-allowed",
                              opacity: currentPage > 1 ? 1 : 0.5,
                            }}
                          />

                          <MdOutlineKeyboardArrowLeft
                            onClick={() => {
                              if (currentPage > 1)
                                setCurrentPage((prev) => prev - 1);
                            }}
                            style={{
                              cursor:
                                currentPage > 1 ? "pointer" : "not-allowed",
                              opacity: currentPage > 1 ? 1 : 0.5,
                            }}
                          />

                          <span>
                            Page {currentPage} of {totalPages}
                          </span>

                          <MdOutlineKeyboardArrowRight
                            onClick={() => {
                              if (currentPage < totalPages)
                                setCurrentPage((prev) => prev + 1);
                            }}
                            style={{
                              cursor:
                                currentPage < totalPages
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentPage < totalPages ? 1 : 0.5,
                            }}
                          />

                          <MdOutlineKeyboardDoubleArrowRight
                            onClick={() => {
                              if (currentPage < totalPages)
                                setCurrentPage(totalPages);
                            }}
                            style={{
                              cursor:
                                currentPage < totalPages
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentPage < totalPages ? 1 : 0.5,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer12 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Addstudentregular12;
